import { getMessaging, getToken } from "firebase/messaging";
import { setToStorage } from "helpers";
import { getFromStorage } from "helpers";
import { STORAGE_KEYS } from "helpers";
import app from "./firebaseKeys";

const firebaseCloudMessaging = {
  // eslint-disable-next-line consistent-return
  init: async () => {
    try {
      const messaging = getMessaging(app);
      const tokenInLocalForage = await getFromStorage(STORAGE_KEYS.fcmToken);

      if (tokenInLocalForage) {
        return tokenInLocalForage;
      }

      const status = await Notification.requestPermission();
      if (status && status === "granted") {
        const fcm_token = await getToken(messaging, {
          vapidKey:
            "BN3utO6cNPuqeIDytiLHkrDNtyePQQNJyiGhF3-HEiHT0pf3s53OLKKgjmJ2ugo7VBxeytMRo-McK1sOXKF3Nyo",
        });

        if (fcm_token) {
          console.log({ fcm_token });
          await setToStorage(STORAGE_KEYS.fcmToken, fcm_token);
          return fcm_token;
        }
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    // }
  },
};

export { firebaseCloudMessaging };
